import React, { CSSProperties } from "react";
import OptionsPopup from "./OptionsPopup";
import { ActionOption, searchGoogleTranslate } from "../utils";
import {
  GOT_IT_ACTION_LABEL,
  SEARCH_GOOGLE_TRANSLATE_LABEL,
  IGNORE_ACTION_LABEL,
  COPY_TO_CLIPBOARD_LABEL,
  CommonPopupProps,
  SEARCH_GOOGLE_LABEL,
} from "./shared";
import { useCurrentDevice } from "../hooks";
import MobileWordPopup from "./MobileWordPopup";
import { SourceLocation, WordView } from "../api-generated";

//TODO: all these diff popup props could extend a common interface
interface WordPopupProps extends CommonPopupProps {
  location: SourceLocation;
  word: WordView;
  onTriggerGotIt: () => void;
  onTriggerDontGotIt: () => void;
  onTriggerMarkAsUnopened: () => void;
  onTriggerIgnore: () => void;
  onTriggerHmmInteresting: () => void;
  onTriggerSayWhat: () => void;
  positionStyle: CSSProperties;
  onTriggerTagWord: () => void;
  onTriggerTagSentence: () => void;
}

const WordPopup: React.FC<WordPopupProps> = ({
  location,
  word,
  isOpen,
  onTriggerSearchGoogle,
  onTriggerSayWhat,
  onTriggerGotIt,
  onTriggerDontGotIt,
  onTriggerMarkAsUnopened,
  onTriggerIgnore,
  onClose,
  onTriggerHmmInteresting,
  onTriggerCopyToClipboard,
  positionStyle,
  onTriggerTagWord,
  onTriggerTagSentence,
}) => {
  const { isPhone, isPad } = useCurrentDevice();

  if (isPad || isPhone) {
    return (
      <MobileWordPopup
        location={location}
        word={word}
        isOpen={isOpen}
        onClose={onClose}
        onTriggerSearchGoogle={onTriggerSearchGoogle}
        onTriggerSayWhat={onTriggerSayWhat}
        onTriggerGotIt={onTriggerGotIt}
        onTriggerDontGotIt={onTriggerDontGotIt}
        onTriggerMarkAsUnopened={onTriggerMarkAsUnopened}
        onTriggerIgnore={onTriggerIgnore}
        onTriggerHmmInteresting={onTriggerHmmInteresting}
        onTriggerTagWord={onTriggerTagWord}
        onTriggerTagSentence={onTriggerTagSentence}
      />
    );
  }

  const options: ActionOption[] = [
    {
      //NB: pretty sure "Interesting..." and not HMM_INTERESTING_LABEL
      //b/c it would wrap to a new line in this popup menu...
      label: "Interesting...",
      onClick: onTriggerHmmInteresting,
    },
    {
      label: SEARCH_GOOGLE_TRANSLATE_LABEL,
      onClick: () => searchGoogleTranslate(word),
    },
    {
      label: SEARCH_GOOGLE_LABEL,
      onClick: onTriggerSearchGoogle,
    },
    { label: GOT_IT_ACTION_LABEL, onClick: onTriggerGotIt },
    { label: "Learning...", onClick: onTriggerDontGotIt },
    { label: IGNORE_ACTION_LABEL, onClick: onTriggerIgnore },
    { label: "Mark as unopened", onClick: onTriggerMarkAsUnopened },
    { label: COPY_TO_CLIPBOARD_LABEL, onClick: onTriggerCopyToClipboard },
  ];

  return (
    <OptionsPopup
      text={word.string}
      options={options}
      isOpen={isOpen}
      onClose={onClose}
      positionStyle={positionStyle}
    />
  );
};

export default WordPopup;
